import React from 'react';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';
import { isStableUIEnabledForTests } from '@confluence/e2e-url-override/entry-points/isStableUIEnabledForTests.ts';
import { fg } from '@confluence/feature-gating';
import { LoadableAfterPaint } from '@confluence/loadable';
import { NthUserOrientation } from '@confluence/experiment-nth-user-orientation/entry-points/NthUserOrientation.ts';

const RovoAnnouncementSplashModalLoadable = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RovoAnnouncementSplashModal" */
				'@confluence/create-with-rovo-announcement-splash/entry-points/RovoAnnouncementSplashModal.ts'
			)
		).RovoAnnouncementSplashModal,
});

export const OnboardingComponentsLoader = (): React.JSX.Element | null => {
	if (isStableUIEnabledForTests()) {
		return null;
	}

	return (
		<>
			<ErrorBoundary attribution={Attribution.CE_MAU}>
				<NthUserOrientation />
			</ErrorBoundary>

			{fg('aifc_onboarding_ga_enabled') && (
				<ErrorBoundary attribution={Attribution.FLYWHEEL_FEATURE_DISCOVERY}>
					<RovoAnnouncementSplashModalLoadable />
				</ErrorBoundary>
			)}
		</>
	);
};
